var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 46.54a22.16 22.16 0 1 1 22.16-22.16A22.18 22.18 0 0 1 24 46.54zm0-42.31a20.16 20.16 0 1 0 20.16 20.15A20.18 20.18 0 0 0 24 4.23z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2.46h2v43.08h-2z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84 23.38h42.31v2H2.84z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.71 46.24-1.42-1.4C30.76 37.26 34.44 29.92 34.2 23c-.2-6.44-3.88-12.85-10.86-19l1.32-1.5C32.08 9 36 15.92 36.2 23c.25 7.42-3.61 15.25-11.49 23.24z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.29 46.24C15.41 38.25 11.55 30.42 11.8 23c.2-7.08 4.12-14 11.54-20.52L24.66 4C17.68 10.15 14 16.56 13.8 23c-.24 6.9 3.44 14.24 10.91 21.82z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.07a30.18 30.18 0 0 1-15.63-4.64l1-1.72c9.8 5.86 19.32 5.86 29.11 0l1 1.72A30.17 30.17 0 0 1 24 15.07zM9.4 40.05l-1-1.71c10.34-6.18 20.83-6.18 31.17 0l-1 1.71c-9.85-5.85-19.37-5.85-29.17 0z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIcon);
export default __webpack_public_path__ + "static/media/global-icon.059df9c62856a0935560b553d39f8bb8.svg";
export { ForwardRef as ReactComponent };